import HeaderContainer from './components/header/HeaderContainer';
import MediaContainer from './components/media/MediaContainer';
import FeatureContainer from './components/feature/FeatureContainer';
import AboutContainer from './components/about/AboutContainer';
import ExperienceContainer from './components/experience/ExperienceContainer';
import SkillsContainer from './components/skills/SkillsContainer';
import ProjectContainer from './components/projects/ProjectContainer';
import OtherProjectContainer from './components/otherprojects/OtherProjectContainer';
import ContactContainer from './components/contact/ContactContainer';
import FooterContainer from './components/footer/FooterContainer';

import AOS from 'aos';
import 'aos/dist/aos.css'; 
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-out-cubic',
      once: true,
      offset: 50,
      delay: 150,
      anchorPlacement: 'top-bottom',
    });
  }, [])
  
  return (
    <div className="App">
      <MediaContainer/>
      <HeaderContainer/>
      <FeatureContainer/>
      <AboutContainer/>
      {/* <ExperienceContainer/> */}
      {/* <SkillsContainer/> */}
      <ProjectContainer/>
      <OtherProjectContainer/>
      <ContactContainer/>
      <FooterContainer/>
    </div>
  );
}

export default App;
